import React, { useEffect, useState } from "react";
import "./createTimeTable.css";

import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import axios from "../../../axios";

// role_as_class_teacher
function ListOfTeachersPop({ setTeacherListPopup, teacherListPopup }) {
  const school_id = JSON.parse(localStorage.getItem("schoolId"));
  const [teacherList, setTeacherList] = useState([]);
  const [allTeacherList, setAllTeacherList] = useState([]);
  // const allTeacherList = useSelector((state) => state.initialData.getAllTeacherList)

  useEffect(() => {
    try {
      if (!school_id) return;
      const getAllTeachersList = async () => {
        try {
          const response = await axios.get(
            `/api/v1/school/teacher/get/school/${school_id}`,
          );
          setAllTeacherList(response?.data?.data);
        } catch (error) {
          console.log(error);
        }
      };
      getAllTeachersList();
    } catch (error) {
      console.log("error", error);
    }
  }, [school_id]);

  console.log(allTeacherList, "allTeacherList");

  useEffect(() => {
    const getTeacherlist = async () => {
      if (!allTeacherList) return;

      const teachers = allTeacherList.map((item) => {
        // ----- Class Teacher -----
        const classTeacherList =
          item?.role_as_class_teacher?.length > 0
            ? item.role_as_class_teacher
                .map((data) => {
                  const standardName = data.standard_id?.name || "";
                  const sectionName = data.section_id?.name || "";
                  return `${standardName}-${sectionName}`;
                })
                .sort((a, b) => a.localeCompare(b))
                .join(", ")
            : "";

        // ----- Class Co-Ordinator -----
        const classCoOrdinatorList =
          item?.role_as_co_ordinator?.length > 0
            ? item.role_as_co_ordinator
                .map((data) => {
                  const standardName = data.standard_id?.name || "";
                  const sectionName = data.section_id?.name || "";
                  return `${standardName}-${sectionName}`;
                })
                .sort((a, b) => a.localeCompare(b))
                .join(", ")
            : "";

        // ----- Subject Teacher (Including CT + CC Subjects) -----
        const subjectSet = new Set();

        // From general_role
        if (item?.general_role?.length > 0) {
          item.general_role.forEach((data) => {
            if (data.subjects_id?.length > 0) {
              const standardName = data.standard_id?.name || "";
              const sectionName = data.section_id?.name || "";
              data.subjects_id.forEach((sub) => {
                const subjectName = sub?.name || "";
                subjectSet.add(`${standardName}-${sectionName}-${subjectName}`);
              });
            }
          });
        }

        // If teacher is CT or CC, and subject exists inside that role
        if (item?.role_as_class_teacher?.length > 0) {
          item.role_as_class_teacher.forEach((data) => {
            if (data.subjects_id?.length > 0) {
              const standardName = data.standard_id?.name || "";
              const sectionName = data.section_id?.name || "";
              data.subjects_id.forEach((sub) => {
                const subjectName = sub?.name || "";
                subjectSet.add(`${standardName}-${sectionName}-${subjectName}`);
              });
            }
          });
        }

        if (item?.role_as_co_ordinator?.length > 0) {
          item.role_as_co_ordinator.forEach((data) => {
            if (data.subjects_id?.length > 0) {
              const standardName = data.standard_id?.name || "";
              const sectionName = data.section_id?.name || "";
              data.subjects_id.forEach((sub) => {
                const subjectName = sub?.name || "";
                subjectSet.add(`${standardName}-${sectionName}-${subjectName}`);
              });
            }
          });
        }

        const subjectTeacherList = Array.from(subjectSet)
          .sort((a, b) => a.localeCompare(b))
          .join(", ");

        return {
          TeacherName: item.name,
          TeacherCode: item.employee_id,
          ClassTeacher: classTeacherList,
          ClassCo_Ordinator: classCoOrdinatorList,
          SubjectTeacher: subjectTeacherList,
          gender: item.gender,
        };
      });

      setTeacherList(teachers);
    };

    getTeacherlist();
  }, [allTeacherList]);
  //export data in excel sheet
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(teacherList);
    XLSX.utils.book_append_sheet(workbook, worksheet, "MySheet1");
    XLSX.writeFile(workbook, "MySheet1.xlsx");
  };

  return (
    <div className=" successful_create_transprant_body ">
      <div className=" p-2 publish_white_containerPre-teacherList shadow">
        <img
          src="/images/cross-circle3.svg"
          className="subClosetBtn"
          alt=""
          onClick={(e) => setTeacherListPopup(false)}
        />
        <div className="head-content">
          <div className="head-content-text">School Teacher Info</div>
          <div>
            <button className="list-button" onClick={downloadExcel}>
              Download List
            </button>
          </div>
        </div>
        <div className="mx-3 main-table-content">
          <table className="table-data">
            <tr>
              <th style={{ padding: "15px" }}>SL. No.</th>
              <th>Teacher Name</th>
              <th>Teacher Code</th>
              <th>Class Teacher</th>
              <th>Co-Ordinator</th>
              <th>Subject Teacher</th>
            </tr>
            {teacherList?.map((curr, index) => {
              return (
                <tr>
                  <td style={{ padding: "15px" }}>{index + 1}</td>
                  <td>{curr.TeacherName}</td>
                  <td>{curr?.TeacherCode}</td>
                  <td>{curr?.ClassTeacher}</td>
                  <td>{curr?.ClassCo_Ordinator}</td>
                  <td style={{ width: "27%" }}>{curr?.SubjectTeacher}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </div>
  );
}

export default ListOfTeachersPop;
